import React from 'react';

import { Modal } from 'antd-v5';
import { FormattedMessage } from 'react-intl';
import { Button } from 'scouting-ui/lib';

import styles from './ImportErrorsModal.module.scss';

interface ImportErrorsModalProps {
  open: boolean;
  errorDesc: string[];
  onClose: () => void;
}

/** Lists the server-returned import error lines with a copy-to-clipboard action. */
const ImportErrorsModal: React.FC<ImportErrorsModalProps> = props => {
  const { open, errorDesc, onClose } = props;

  const handleCopy = () => {
    const text = errorDesc.join('\n');
    if (navigator.clipboard?.writeText) {
      navigator.clipboard.writeText(text);
      return;
    }
    // Fallback for browsers without the async clipboard API.
    const textField = document.createElement('textarea');
    textField.value = text;
    document.body.appendChild(textField);
    textField.select();
    document.execCommand('copy');
    textField.remove();
  };

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={false}
      width={720}
      destroyOnClose
      title={
        <FormattedMessage
          id="advancementImport.ErrorsModal.title"
          values={{ count: errorDesc.length }}
        />
      }
    >
      <div className={styles.plainText}>
        {errorDesc.map((error, i) => (
          <span key={i}>{error}</span>
        ))}
      </div>
      <div className={styles.buttonWrapper}>
        <Button type="default" onClick={handleCopy}>
          <FormattedMessage id="advancementImport.ErrorsModal.copyButton" />
        </Button>
      </div>
    </Modal>
  );
};

export default ImportErrorsModal;
